import { ClientFulfillmentGroupFolder } from "@redotech/redo-model/views/folders";
import { ClientFulfillmentGroupView } from "@redotech/redo-model/views/views";
import * as z from "zod";
import { null as zNull } from "zod";
export const getViewsAndFolders = {
  name: "getViewsAndFolders" as const,
  input: zNull(),
  output: z.object({
    folders: z.array(ClientFulfillmentGroupFolder),
    views: z.array(ClientFulfillmentGroupView),
  }),
};
